export default {"src":"/_next/static/media/skillz_wordmark_white.5d9b1890.svg","height":21,"width":89,"blurWidth":0,"blurHeight":0};